// extracted by mini-css-extract-plugin
export default {"layout":"DashboardLayout_layout__FMfAz","layout__main":"DashboardLayout_layout__main__Bcm4m"};